import { MathImagePicker, MathPickerContribution } from "../constants";

import { DefaultMathImagePicker } from "./image-picker";

let loadImagePick = !1;

export function bindImageMathPickerContribution(container) {
    loadImagePick || (loadImagePick = !0, container.bind(MathImagePicker).toDynamicValue((() => new DefaultMathImagePicker)).inSingletonScope(), 
    container.bind(MathPickerContribution).toService(MathImagePicker));
}
//# sourceMappingURL=image-module.js.map
